module.exports = __webpack_public_path__ + "img/tick.829741a9.svg";